// import { menuItemOptions } from '../../../lib/menuItemOptions'
import { useFormContext } from 'react-hook-form'
import Switch from '../../form/switch/Switch';
import Label from "../../../components/form/Label";
import { 
  Hot, 
  Chili,
  Vegan,
  GlutenFree,
  CornFree,
  DairyFree,
  EggsFree,
  FishFree,
  LegumesFree,
  PeanutFree,
  SeedsFree,
  ShellfishFree,
  TreeNutsFree,
  SugarFreeOutline
} from '../../../icons'

import type { 
  MenuItem
} from '../../../types/menuItemTypes';

type MenuItemOptionsProps = {
  menuItem?: MenuItem;
}

const MenuItemOptions: React.FC<MenuItemOptionsProps> = ({menuItem}) => {
  const { setValue } = useFormContext();
  const handleSwitchOptions = (event: boolean, option: string) => {
    setValue(option, event, {
      shouldValidate: true,
      shouldDirty: true
    });
  }

  return (
    <div className='rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.03]'>
      <Label className='my-4'>Main</Label>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <Hot className="size-16 mr-2 fill-[orangered]" />
          <Switch
            label="Hot"
            defaultChecked={menuItem?.hot}
            onChange={(e) => handleSwitchOptions(e, 'hot')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <Chili className="size-16 mr-2 fill-[indianred]" />
          <Switch
            label="Chili"
            defaultChecked={menuItem?.chili}
            onChange={(e) => handleSwitchOptions(e, 'chili')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <Vegan className="size-16 mr-2 fill-[forestgreen]" />
          <Switch
            label="Vegan"
            defaultChecked={menuItem?.vegan}
            onChange={(e) => handleSwitchOptions(e, 'vegan')}
          />
        </div>
      </div>

      <Label className='my-4'>Allergen</Label>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <GlutenFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Gluten free"
            defaultChecked={menuItem?.glutenFree}
            onChange={(e) => handleSwitchOptions(e, 'glutenFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <CornFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Corn free"
            defaultChecked={menuItem?.cornFree}
            onChange={(e) => handleSwitchOptions(e, 'cornFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <DairyFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Dairy free"
            defaultChecked={menuItem?.dairyFree}
            onChange={(e) => handleSwitchOptions(e, 'dairyFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <EggsFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Eggs free"
            defaultChecked={menuItem?.eggsFree}
            onChange={(e) => handleSwitchOptions(e, 'eggsFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <FishFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Fish free"
            defaultChecked={menuItem?.fishFree}
            onChange={(e) => handleSwitchOptions(e, 'fishFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <LegumesFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Legumes free"
            defaultChecked={menuItem?.legumesFree}
            onChange={(e) => handleSwitchOptions(e, 'legumesFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <PeanutFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Peanut free"
            defaultChecked={menuItem?.peanutFree}
            onChange={(e) => handleSwitchOptions(e, 'peanutFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <SeedsFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Seeds free"
            defaultChecked={menuItem?.seedsFree}
            onChange={(e) => handleSwitchOptions(e, 'seedsFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <ShellfishFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Shellfish free"
            defaultChecked={menuItem?.shellfishFree}
            onChange={(e) => handleSwitchOptions(e, 'shellfishFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <TreeNutsFree className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Tree nuts free"
            defaultChecked={menuItem?.treeNutsFree}
            onChange={(e) => handleSwitchOptions(e, 'treeNutsFree')}
          />
        </div>
        <div className='flex flex-row justify-start border border-gray-200 rounded-2xl dark:border-gray-500 p-4'>
          <SugarFreeOutline className="size-16 mr-2 dark:fill-white" />
          <Switch
            label="Sugar free"
            defaultChecked={menuItem?.sugarFree}
            onChange={(e) => handleSwitchOptions(e, 'sugarFree')}
          />
        </div>
      </div>
    </div>
  )
}

export default MenuItemOptions